import { SortOrderEnum } from '../../../../api/shared/enums/sort-order.enum';

/**
 * Prefer modified date, if it's not set, use createdDate
 */
export function sortByDate(a, b): number {
    // Prefer modified date, if it's not set, use createdDate
    const aDate = a.modifiedDate || a.createdDate;
    const bDate = b.modifiedDate || b.createdDate;
    return +bDate - +aDate;
}

export function sortArrayByString(array: any[], sortField: string, sortOrder: SortOrderEnum = SortOrderEnum.ascending): void {
    array.sort((a, b) => {
        const valA: string = a[sortField] ?? '';
        const valB: string = b[sortField] ?? '';
        const leadingDigitsA = valA.match(/(^\d+)/i);
        const leadingDigitsB = valB.match(/(^\d+)/i);

        let res: number = 0;

        if (leadingDigitsA?.length && leadingDigitsB?.length) {
            res = parseInt(leadingDigitsA[0], 10) - parseInt(leadingDigitsB[0], 10);
            if (res === 0) {
                res = valA.localeCompare(valB);
            }
        } else {
            res = valA.localeCompare(valB);
        }

        return sortOrder === SortOrderEnum.ascending ? res : -res;
    });

}

export function sortArray(array: any[], sortField: string, sortOrder: SortOrderEnum = SortOrderEnum.ascending): void {
    array.sort((a, b) => {
        let res: number = 0;

        if (a[sortField] > b[sortField]) {
            res = 1;
        } else if (a[sortField] < b[sortField]) {
            res = -1;
        };

        return sortOrder === SortOrderEnum.ascending ? res : -res;
    });
}


export function sortArrayByPredefinedEnumOrder(array: any[], order: any[]): void {
    const orderMap = new Map(order.map((field, index) => [field, index]));

    array.sort((a, b) => (orderMap.get(a) ?? Infinity) - (orderMap.get(b) ?? Infinity));
}

export function sortSentiment(arr: string[]): string[] {
    const sentimentOrder = [
        'NOT_AVAILABLE',
        'NEGATIVE',
        'NEUTRAL',
        'POSITIVE'
    ];

    const normalize = (value: string): string =>
        value.trim().replace(/\s+/g, '_').toUpperCase();

    const sorted = arr
        .slice()
        .sort((a, b) => {
            return sentimentOrder.indexOf(normalize(a)) - sentimentOrder.indexOf(normalize(b));
        });

    for (let i = 0; i < arr.length; i++) {
        arr[i] = sorted[i];
    }

    return arr;
}


